
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import ChannelGroupTitle from 'components/ChannelGroupTitle'
import ChannelTitle from 'components/ChannelTitle'

export default class TrafficInsightViewChannel extends React.Component {
  static propTypes = {
    channelGroupId: PropTypes.string,
    channelId: PropTypes.string
  }

  render() {
    const {channelGroupId, channelId} = this.props

    return (
      <div className='traffic-insight-view-channel'>
        <div className='traffic-insight-view-channel_group-title'>
          <ChannelGroupTitle id={channelGroupId} noIcon />
        </div>
        <div className='traffic-insight-view-channel_title'>
          <ChannelTitle id={channelId} iconSize='32px' />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/OverviewTable/ChannelCell/index.js